import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loader-spinner";
import { Form, Button, Image, Col, Row, Modal, Table } from "react-bootstrap";
import {
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
  Radio,
  TextField,
} from "@material-ui/core";

import Switch from "react-switch";
import { NavLink, useHistory } from "react-router-dom";
//import SuperAdminDeleteOffer from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteOffer";
import SuperAdminOfferDelete from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminOfferDelete";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ListMarchantTableHead from "./TableHeadBody/ListMarchantTableHead";
import ListMerchantTableBody from "./TableHeadBody/ListMerchantTableBody";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  super_admin_get_selected_restaurant_list,
  super_admin_get_city,
} from "../../../../store/actions/SuperAdminActions/superAdminOnlineAndOfflineAction";

// Animations
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const ViewOfferDetailsOnlineAdmin = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [selectedTab, setSelectedTab] = useState(props?.currentTab);
  const [showView, setShowView] = useState(false);
  const handleShowView = () => {
    setShowView(true);
  };
  const handleCloseView = () => setShowView(false);
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [showLog, setShowLog] = useState(false);

  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    dispatch(
      super_admin_get_selected_restaurant_list(
        token,
        props?.data && props?.data?._id
      )
    );
    dispatch(
      super_admin_get_city(token, props?.data?.country, props?.data?.state)
    );
  }, [props?.data && props?.data?._id]);

  const [state, setState] = useState({
    restaurantType: "",
    restaurantCity: "",
  });

  const [restaurantTypeFilter, setRestaurantTypeFilter] = useState("");
  const [restaurantCityFilter, setRestaurantCityFilter] = useState("");

  const [showSearch, setShowSearch] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [searchData, setSearchData] = useState("");

  const onClickDisplaySearch = (e) => {
    e.preventDefault();
    setShowSearch(!showSearch);
    setShowFilter(false);
  };
  const onClickDisplayFilter = (e) => {
    e.preventDefault();
    setShowFilter(!showFilter);
    setShowSearch(false);
  };

  /****************************
   * @DESC Filler All Action
   ****************************/
  const onClickSaveFilter = () => {
    setRestaurantTypeFilter(state?.restaurantType);
    setRestaurantCityFilter(state?.restaurantCity);
    setShowFilter(false);
  };

  const onClickResetFilter = () => {
    setRestaurantTypeFilter("");
    setRestaurantCityFilter("");
    setShowFilter(false);
  };

  /**********************************************
   * @DESC Set User and Vendor Information
   **********************************************/
  const [getVendorUserInfo, setVendorUserInfo] = useState([]);
  const [finalVendorFilter, setFinalVendorFilter] = useState(0);
  useEffect(() => {
    setVendorUserInfo(props?.selectRestaurantList);
  }, [props.selectRestaurantList]);

  const vendorUserData = getVendorUserInfo && getVendorUserInfo;
  let filteredData = [];
  useEffect(() => {
    setFinalVendorFilter(filteredData && filteredData.length);
  }, [filteredData]);

  const RenderVendorUserTable = (actionBy) => {
    if (restaurantTypeFilter === "" && restaurantCityFilter === "") {
      filteredData = vendorUserData.filter((getall) => {
        return getall;
      });
    } else if (restaurantTypeFilter !== "") {
      filteredData = vendorUserData.filter(
        (getall) =>
          getall &&
          getall?.primary_restaurant_type?.title === restaurantTypeFilter
      );
    } else if (restaurantCityFilter !== "") {
      filteredData = vendorUserData.filter(
        (getall) => getall && getall?.city === restaurantCityFilter
      );
    }

    if (searchData) {
      let search = new RegExp(searchData, "i");
      filteredData = vendorUserData.filter((getall) => {
        if (search.test(getall?._id)) {
          return getall;
        } else if (search.test(getall?.restaurant_name)) {
          return getall;
        } else {
          return false;
        }
      });
    }

    if (!isEmpty(filteredData)) {
      return filteredData.map((data, index) => (
        <React.Fragment key={index}>
          <ListMerchantTableBody viewAccess="ViewDashboard" userType={data} />
        </React.Fragment>
      ));
    }
  };

  const onOnlineOfferEditClickHandler = (offer) => {
    // props.onClickCloseView();
    history.push({
      pathname: `/superadminoffers/edit-admin-online-offer/${offer._id}`,
      state: { editData: offer },
    });
  };

  return (
    <>
      <Modal
        show={props?.onClickshowView}
        onHide={props?.onClickCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Offer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <hr className="m-0" />
          <div className="enTabs d-flex flex-wrap align-items-center mb-4 mb-2">
            <Button
              variant="link"
              onClick={() => props.handleTab("1")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                props?.currentTab === "1" ? "active" : ""
              }`}
            >
              General Information
            </Button>
            <Button
              variant="link"
              onClick={() => props.handleTab("2")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                props?.currentTab === "2" ? "active" : ""
              }`}
            >
              Offer Settings
            </Button>
          </div>
          {props?.currentTab === "1" && (
            <React.Fragment>
              <div className="pt-3 d-flex justify-content-between">
                <div>
                  <div className="f12-400 opacity5">Offer Name</div>
                  <div className="d-flex align-items-center pt-2">
                    <div className="f16-500">
                      {props?.data && props?.data.name}
                    </div>
                    <div className="enSuccessLBL ml-2">Online</div>
                  </div>
                </div>
                <div className="d-flex">
                  <Button
                    onClick={() =>
                      onOnlineOfferEditClickHandler(props?.data && props?.data)
                    }
                    className="enIconBtn mr-3 bg-transparent"
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </Button>
                  {/* <SuperAdminDeleteOffer
                    handleCloseView={handleCloseView}
                    actionBy={"vendor"}
                    insideDelete={"viewDelete"}
                    offerId={props?.data && props?.data._id}
                  /> */}
                  <SuperAdminOfferDelete
                    offerId={props?.data?._id}
                    viewAccess="viewDeleteButton"
                    onClickCloseViewOnline={props?.onClickCloseView}
                  />
                </div>
              </div>

              <div className="pt-4 f12-400 opacity5">Description</div>
              <div className="pt-2 f12-400 text-break">
                {props?.data && props?.data.description}
              </div>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Main Carousel</div>
                  <div className="d-flex align-items-center">
                    <div className="f14-500 mr-2">
                      {props?.data && props?.data?.send_to_carousel
                        ? "Active"
                        : "Inactive"}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">Status</div>
                  <div className="d-flex align-items-center">
                    <div className="f14-500 mr-2">
                      {" "}
                      {props?.data && props?.data.active ? "Yes" : "No"}
                    </div>
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../../assets/images/UserManagement/calendar.svg")}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700">
                      {" "}
                      {moment(props?.data && props?.data.start_date).format(
                        "DD/MM/YYYY"
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700">
                      {" "}
                      {moment(props?.data && props?.data.start_date).format(
                        "hh:mm A"
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">End Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../../assets/images/UserManagement/calendar.svg")}
                      alt="Calender"
                      title="Calender"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700 text-red">
                      {" "}
                      {moment(props?.data && props?.data.end_date).format(
                        "DD/MM/YYYY"
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">End Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700 text-red">
                      {" "}
                      {moment(props?.data && props?.data.end_date).format(
                        "hh:mm A"
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Offer Code</div>
                  <div className="f16-700">
                    {" "}
                    {props?.data && props?.data.coupon_code}
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">
                    Maximum Usage Limit
                  </div>
                  <div className="f16-700">
                    {props?.data && props?.data.maximum_usage_limit}
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Views</div>
                  <div className="f16-700">
                    {props?.data && props?.data.offerViews}
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">Used</div>
                  <div className="f16-700">
                    {props?.data && props?.data.offerUsed}
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">User Usage Limit</div>
                  <div className="f16-700">
                    {props?.data && props?.data?.useLimit}
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Frequency</div>
                  <div className="f16-700">
                    {props?.data && props?.data?.useFrequency}
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">
                    Maximum Usage Limit for Entire Offer
                  </div>
                  <div className="f16-700">
                    {props?.data && props?.data?.maxUsage}
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Offer settings*</div>
                  <div className="f16-700">
                    {props?.data && props?.data.settlementType === "ADMIN"
                      ? "Amealio Offer"
                      : "Offer splits between Merchant & Admin"}
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={6}
                  className="my-3 border-right"
                  style={{ wordBreak: "break-word" }}
                >
                  <div className="pb-2 f12-400 opacity5">Country</div>
                  <div className="f16-700">
                    {props?.data && props?.data.country}
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={6}
                  className="my-3 border-right"
                  style={{ wordBreak: "break-word" }}
                >
                  <div className="pb-2 f12-400 opacity5">State</div>
                  <div className="f16-700 text">
                    {props?.data && props?.data.state}
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={6}
                  className="my-3 border-right"
                  style={{ wordBreak: "break-word" }}
                >
                  <div className="pb-2 f12-400 opacity5">City</div>
                  <div className="f16-700">
                    {props?.data && props?.data.city}
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col md={12}>
                  <h5 className="f11-500 mb-2">List of Active Merchants</h5>
                  <Row>
                    <Col md={6} className="d-flex align-items-center">
                      <div className="d-flex align-items-center">
                        <Image
                          alt="Search"
                          title="Search"
                          width="60px"
                          src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                          onClick={(e) => onClickDisplaySearch(e)}
                        />
                        {/* <Image
                          src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                          width="45px"
                          alt="Filter"
                          title="Filter"
                          onClick={(e) => onClickDisplayFilter(e)}
                        /> */}
                      </div>
                    </Col>
                    <Col
                      md={6}
                      className="col-md-6 d-flex align-items-center justify-content-end"
                    >
                      <h5 className="f12-400">
                        Total Number of Merchants :{" "}
                        {props.auth.secondary_loader ? (
                          <div className="ml-2">
                            <Loader
                              type="ThreeDots"
                              color="#00BFFF"
                              height={25}
                              width={25}
                            />
                          </div>
                        ) : (
                          finalVendorFilter && finalVendorFilter
                        )}
                      </h5>
                    </Col>
                    <div className="col-12">
                      {showSearch && (
                        <div className="my-3">
                          <ZoomDiv>
                            <div className="w-25">
                              <Form.Control
                                type="text"
                                placeholder="Search"
                                value={searchData}
                                onChange={(e) => setSearchData(e.target.value)}
                                className="amSearch"
                              />
                            </div>
                          </ZoomDiv>
                        </div>
                      )}
                      {showFilter && (
                        <div
                          className="container-fluid p-4"
                          style={{ backgroundColor: "#ffffff" }}
                        >
                          <Row>
                            <Col md={6}>
                              <Form.Group>
                                <FormControl
                                  variant="outlined"
                                  className="w-100"
                                >
                                  <InputLabel htmlFor="outlined-Status">
                                    City
                                  </InputLabel>
                                  <Select
                                    value={state?.restaurantCity}
                                    onChange={(e) =>
                                      setState({
                                        ...state,
                                        restaurantCity: e.target.value,
                                      })
                                    }
                                    label="City"
                                    inputProps={{
                                      name: "restaurantCity",
                                      id: "outlined-Status",
                                    }}
                                    IconComponent={KeyboardArrowDownIcon}
                                  >
                                    <option value={""} disabled>
                                      Select option
                                    </option>
                                    {props?.getCity &&
                                      props?.getCity?.map((data, index) => (
                                        <option value={data} key={index}>
                                          {data}
                                        </option>
                                      ))}
                                  </Select>
                                </FormControl>
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group>
                                <FormControl
                                  variant="outlined"
                                  className="w-100"
                                >
                                  <InputLabel htmlFor="outlined-Status">
                                    Restaurant Type
                                  </InputLabel>
                                  <Select
                                    value={state?.restaurantType}
                                    onChange={(e) =>
                                      setState({
                                        ...state,
                                        restaurantType: e.target.value,
                                      })
                                    }
                                    label="Restaurant Type"
                                    inputProps={{
                                      name: "restaurantType",
                                      id: "outlined-Status",
                                    }}
                                    IconComponent={KeyboardArrowDownIcon}
                                  >
                                    <option value={""} disabled>
                                      Select option
                                    </option>
                                    {props?.restaurantType.map(
                                      (data, index) => (
                                        <option value={data?.title} key={index}>
                                          {data?.title}
                                        </option>
                                      )
                                    )}
                                  </Select>
                                </FormControl>
                              </Form.Group>
                            </Col>
                          </Row>
                          <div class="mt-5 d-flex">
                            <button
                              type="button"
                              onClick={() => onClickResetFilter()}
                              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                              title="Reset Filter"
                            >
                              Reset
                            </button>
                            <button
                              type="button"
                              onClick={() => onClickSaveFilter()}
                              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                              title="Search Filter"
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    <Col sm={12}>
                      {props.auth.secondary_loader ? (
                        <Loader
                          type="ThreeDots"
                          color="#00BFFF"
                          height={25}
                          width={25}
                        />
                      ) : vendorUserData && vendorUserData.length !== 0 ? (
                        <div
                          className="col-12 p-0 user-table-reusable-superadmin my-2"
                          style={{
                            // maxHeight: "400px",
                            // overflow: "auto",
                            border: "1px solid #00000029",
                            borderRadius: "10px",
                          }}
                        >
                          <Table
                            style={{
                              borderSpacing: 0,
                              borderCollapse: "collapse",
                            }}
                          >
                            <thead>
                              <ListMarchantTableHead viewAccess="ViewDashboard" />
                            </thead>
                            <div
                              id="style-4"
                              style={{
                                maxHeight: "400px",
                                overflow: "auto",
                              }}
                            >
                              {RenderVendorUserTable()}
                            </div>
                          </Table>
                        </div>
                      ) : (
                        <React.Fragment>
                          <div className="text-center">
                            <h3 className="f16-500 opacity5">
                              NO RECORDS FOUND
                            </h3>
                          </div>
                        </React.Fragment>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">View Offer Image</div>
                <div className="d-flex flex-wrap">
                  <SimpleReactLightbox>
                    {((props?.data && props?.data.photos) || []).map(
                      (url, index) => (
                        <div
                          className="enIconUploaded bg-transparent"
                          key={index}
                        >
                          <SRLWrapper options={options}>
                            <Image
                              src={url}
                              alt="Document"
                              className="rounded img-thumbnail"
                              fluid
                            />
                          </SRLWrapper>
                        </div>
                      )
                    )}
                  </SimpleReactLightbox>
                </div>
              </div>
              {props?.data && props?.data.offerVideo === "" ? (
                ""
              ) : (
                <div className="pb-4">
                  <div className="pb-2 f12-400 opacity5">View Video</div>
                  <div className="w-25">
                    <SimpleReactLightbox>
                      <SRLWrapper options={options}>
                        <video width="100%" height="100%" controls>
                          <source
                            src={props?.data && props?.data.offerVideo}
                            type="video/mp4"
                          />
                        </video>
                      </SRLWrapper>
                    </SimpleReactLightbox>
                  </div>
                </div>
              )}
              <div className="pb-4">
                <div className="f12-400 opacity5">Terms and Conditions</div>
                <div className="pt-2 f12-400 text-break">
                  {props?.data && props?.data.terms_and_condition}
                </div>
              </div>
              <div className="pb-4">
                <div className="f12-400 opacity5">Refund & Cancellation</div>
                <div className="pt-2 f12-400 text-break">
                  {props?.data && props?.data.refund_and_cancellation}
                </div>
              </div>
            </React.Fragment>
          )}
          {props?.currentTab === "2" && (
            <React.Fragment>
              <Row className>
                <Col lg={3} md={6} className="py-3 border-right">
                  <div className="f12-400 opacity5 pb-3">
                    Coupon Discount Type
                  </div>
                  <div className="f16-500">
                    {props?.data && props?.data.isPercentage
                      ? "Percentage"
                      : "Fixed Amount"}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3 border-right">
                  <div className="f12-400 opacity5 pb-3">Coupon Discount</div>
                  <div className="f16-500">{`${
                    props?.data && props?.data.isPercentage
                      ? `${props?.data && props?.data.discount}%`
                      : `${props?.data && props?.data.discount}Rs`
                  }`}</div>
                </Col>
                <Col lg={4} md={8} className="py-3">
                  <div className="f12-400 opacity5 pb-3">
                    Applicable To Services
                  </div>
                  <div className="f16-500">
                    {props?.data?.service_type.length <= 0
                      ? "-"
                      : props?.data?.service_type.map((item, index) => {
                          if (index === 0) {
                            return item;
                          } else if (item) {
                            return ", " + item;
                          }
                        })}
                  </div>
                </Col>
                <Col lg={2} md={4} className="py-3">
                  <div className="d-flex">
                    <div
                      className="enIconBtn mr-3"
                      onClick={() =>
                        onOnlineOfferEditClickHandler(
                          props?.data && props?.data
                        )
                      }
                    >
                      <Image
                        src={require("../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </div>
                    <SuperAdminOfferDelete
                      offerId={props?.data?._id}
                      viewAccess="viewDeleteButton"
                      onClickCloseViewOnline={props?.onClickCloseView}
                    />
                    {/* <SuperAdminDeleteOffer
                      // offerId={
                      //   restaurantDetailFromOfferId &&
                      //   restaurantDetailFromOfferId._id
                      // }
                      // handleCloseView={handleCloseView}
                      handleCloseView={handleCloseView}
                      actionBy={"vendor"}
                      insideDelete={"viewDelete"}
                      offerId={props?.data && props?.data._id}
                    /> */}
                  </div>
                </Col>
                <hr />
              </Row>
              <Row className>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-400 opacity5 pb-3">Min. Order Value</div>
                  <div className="f16-500">
                    {props?.data?.minimum_order_applied !== undefined &&
                    props?.data?.minimum_order_applied !== null &&
                    props?.data?.minimum_order_applied !== ""
                      ? `₹ ${props?.data?.minimum_order_applied}`
                      : `-`}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-400 opacity5 pb-3">Max. Order Value</div>
                  <div className="f16-500">
                    {props?.data?.maximum_order_applied !== undefined &&
                    props?.data?.maximum_order_applied !== null &&
                    props?.data?.maximum_order_applied !== ""
                      ? `₹ ${props?.data?.maximum_order_applied}`
                      : `-`}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-400 opacity5 pb-3">
                    Max. Discount Value
                  </div>
                  <div className="f16-500">
                    {props?.data?.maximum_discount_applied !== undefined &&
                    props?.data?.maximum_discount_applied !== null &&
                    props?.data?.maximum_discount_applied !== ""
                      ? `₹ ${props?.data?.maximum_discount_applied}`
                      : `-`}
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          <hr />
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              View more details{" "}
              <Image
                src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-4">
                <Col lg={4} md={6} className="py-3">
                  <div className="f12-500 pb-3">Offer ID</div>
                  <div className="f14-400">
                    #{props?.data && props?.data._id}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Changed Date / Time</div>
                  <div className="f14-400">
                    {moment(props?.data && props?.data.updatedAt).format(
                      "Do MMMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {moment(props?.data && props?.data.updatedAt).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3 pl-4">
                  <div className="f12-500 pb-3">Created Date / Time</div>
                  <div className="f14-400">
                    {moment(props?.data && props?.data.createdAt).format(
                      "Do MMMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {moment(props?.data && props?.data.createdAt).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col lg={2} md={6} className="py-3 pl-4">
                  <div className="f12-500 pb-3">Point of Entry</div>
                  <div className="f14-400">
                    {props?.data && props?.data.pointOfEntry}
                  </div>
                </Col>
              </Row>
            </div>
          )}
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <thead>
                  <tr>
                    <th className="">
                      <div className="f12-500">Date</div>
                    </th>
                    <th>
                      <div className="f12-500">Operation</div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {((props?.data && props?.data.auditLogs) || []).map(
                    (data, index) => (
                      <tr key={index}>
                        <td>
                          <div className="f12-500">
                            {moment(data.timestamp).format("Do MMMM YYYY")}
                          </div>
                          <div className="f12-500">
                            {moment(data.timestamp).format("hh:mm A")}
                          </div>
                        </td>
                        <td>
                          <div className="f12-500">{data.message}</div>
                        </td>
                        <td>
                          <div className="f12-500">
                            {data.initiator === "VENDOR"
                              ? "You"
                              : data.initiator}
                          </div>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

ViewOfferDetailsOnlineAdmin.propTypes = {
  auth: PropTypes.object.isRequired,
  super_admin_get_selected_restaurant_list: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  getCity: state.superAdminOfflineOnlineOffers?.city,
  selectRestaurantList:
    state?.superAdminOfflineOnlineOffers?.selectedBusinessList?.restaurants,
  restaurantType: state.category?.restaurant_type,
});

export default connect(mapStateToProps, {
  super_admin_get_selected_restaurant_list,
  super_admin_get_city,
})(ViewOfferDetailsOnlineAdmin);
